import {
  FeatureCta,
  FeatureDetailSection,
  FeatureHero,
  FeaturePageShell,
} from "./_Shell";

export default function AnswersEveryCall() {
  return (
    <FeaturePageShell>
      <FeatureHero
        title="Never miss another call"
        subtitle="Every missed call is a missed opportunity. NeuroSphere picks up 24/7 — nights, weekends, lunch rush — with a natural AI voice that sounds like a real person."
      />

      <div className="max-w-3xl mx-auto px-6 space-y-6 pb-8">
        <FeatureDetailSection
          icon="ri-time-line"
          title="Always available, never on hold"
          description="Your AI answers instantly, every time. No voicemail. No hold music. No missed calls during busy hours or after closing time."
        />
        <FeatureDetailSection
          icon="ri-mic-line"
          title="Sounds like a real person"
          description="Powered by ElevenLabs voice technology, your AI receptionist speaks naturally and warmly — not like a robot. Callers often don't know it's AI."
        />
        <FeatureDetailSection
          icon="ri-settings-3-line"
          title="Handles your most common calls"
          description="FAQs, hours, directions, messages, transfers — your AI handles the calls that used to eat up your team's time."
        />
      </div>

      <FeatureCta headline="Stop missing calls. Book a demo." />
    </FeaturePageShell>
  );
}
